import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Link from "../../Link";

const PartialContentTemplate = ({
  classNames,
  headerHTML,
  contentHTML,
  contentClassNames,
  imgURL,
  imgMaxWidth,
  btnLabel,
  btnClassNames,
  btnHref,
  isPartialCentered,
  children,
  containerStyles,
  isDataScroll,
}) => {
  const dataScroll = {
    "data-sal": "slide-up",
    "data-sal-duration": 100,
    "data-sal-easing": "ease-in-quad",
    // "data-sal-delay": 150,
  };

  return (
    <div
      className={cx("content-template partial-content-template", classNames)}
    >
      <div className="container grid-container" style={containerStyles}>
        <h2
          className={`header grid-col-12 text-center`}
          dangerouslySetInnerHTML={{ __html: headerHTML }}
          {...(isDataScroll && { ...dataScroll, "data-sal-delay": 100 })}
        />

        {contentHTML && (
          <div
            className={cx("excerpt grid-col-12 text-center", contentClassNames)}
            dangerouslySetInnerHTML={{ __html: contentHTML }}
            {...(isDataScroll && { ...dataScroll, "data-sal-delay": 150 })}
          />
        )}

        {children && (
          <div
            className={cx(`content`, {
              "grid-col-12": !isPartialCentered,
              "partial--centered": isPartialCentered,
              "grid-col-lg-5": imgURL,
            })}
          >
            {children}
          </div>
        )}

        {imgURL && (
          <div
            className={cx(
              "partial-image grid-col-12 w-100 h-auto text-center align-self-center",
              {
                "grid-col-lg-7": children,
              }
            )}
            {...(isDataScroll && dataScroll)}
          >
            <img
              src={imgURL}
              alt=""
              style={{ maxWidth: `${imgMaxWidth}px` }}
              loading="lazy"
            />
          </div>
        )}

        {btnLabel && (
          <div
            className="grid-col-12 text-center"
            {...(isDataScroll && { ...dataScroll, "data-sal-delay": 200 })}
          >
            <Link
              to={btnHref}
              className={cx("button text-center mt-4", btnClassNames)}
              type="button"
            >
              {btnLabel}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

PartialContentTemplate.propTypes = {
  classNames: PropTypes.string,
  headerHTML: PropTypes.any,
  contentHTML: PropTypes.any,
  imgName: PropTypes.string,
  imgMaxWidth: PropTypes.number,
  btnLabel: PropTypes.string,
  btnClassNames: PropTypes.string,
  btnHref: PropTypes.string,
  isPartialCentered: PropTypes.bool,
  containerStyles: PropTypes.object,
};

PartialContentTemplate.defaultProps = {
  imgMaxWidth: 700,
  isPartialCentered: false,
  btnClassNames: "button-secondary button-rounded",
  isDataScroll: true,
};

export default PartialContentTemplate;
